'use strict';

var react = require('react');
var hooks_useMountedState = require('./useMountedState.js');

function useAsyncEffect(effect, deps) {
    const isMounted = hooks_useMountedState.useMountedState();
    react.useEffect(() => {
        void effect(isMounted);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

exports.useAsyncEffect = useAsyncEffect;
//# sourceMappingURL=useAsyncEffect.js.map
